import React from "react";
import PrmTablePatientFIO from "./param-table-patient-FIO";
import PrmTablePatientBirth from "./param-table-patient-birth";
import PrmTableExamNo from "./param-table-exam-no";
import PrmTableExamDate from "./param-table-exam-date";
import PrmTableExamAim from "./param-table-exam-aim";
import PrmTableHR from "./param-table-HR";
import PrmTableIntervals from "./param-table-intervals";
import PrmTableST from "./param-table-ST";
import PrmTableTransZone from "./param-table-trans-zone";

import "./param-tables.scss";
import { aim_dialog, paramTable_dialog, graphIntervals_dialog } from "../../popup-dialog-manager/constants";

const ParamTables = props => {
    const { report, settings, fd, openDialog, popupable, needIntervals, needDialogTableParams } = props,
        {
            exam,
            exam_date,
            exam_time,
            aim,
            appointed,
            representativeCmpx,
            HR_RR,
            stimulator = false,
            stimulatorType = "",
            patient
        } = report,
        { HR, RRmin, RRmax, RRavg } = HR_RR,
        { name, sex, birthday, age } = patient,
        { QTcAlg } = settings;
    let STDeprTo_uV = null,
        STElevTo_uV = null,
        transZone = null,
        indexSokolovLyon = null,
        STDeprTo_Lead = null,
        STElevTo_Lead = null;
    if (representativeCmpx) ({ STDeprTo_uV, STElevTo_uV, STDeprTo_Lead, STElevTo_Lead, transZone, indexSokolovLyon } = representativeCmpx);

    return (
        <div className="medical-report__section" spellCheck="false">
            <PrmTablePatientFIO {...{ name, sex }} />
            <PrmTablePatientBirth {...{ age, birthday }} />
            <PrmTableExamNo {...{ exam }} />
            <PrmTableExamDate {...{ exam_date, exam_time }} />
            <div className={popupable ? "popup-able" : ""}>
                {popupable ? (
                    <button className="popup-open-btn" data-popup-window="paramTable-popup-window" onClick={() => openDialog(aim_dialog)}>
                        {"\ue800"}
                    </button>
                ) : null}
                <PrmTableExamAim {...{ aim, appointed }} />
            </div>

            <div className={popupable && needDialogTableParams ? "popup-able" : ""}>
                {popupable && needDialogTableParams ? (
                    <button
                        className="popup-open-btn"
                        data-popup-window="paramTable-popup-window"
                        onClick={() => openDialog(paramTable_dialog)}>
                        {"\ue800"}
                    </button>
                ) : null}
                <PrmTableHR {...{ HR, RRmin, RRmax, RRavg, stimulator, stimulatorType }} />
                <PrmTableIntervals
                    {...{ representativeCmpx, QTcAlg, fd, needIntervals, onVerificateClick: () => openDialog(graphIntervals_dialog) }}
                />
                <PrmTableST {...{ STDeprTo_uV, STElevTo_uV, STDeprTo_Lead, STElevTo_Lead, needIntervals }} />
                <PrmTableTransZone {...{ transZone, indexSokolovLyon, needIntervals }} />
            </div>
        </div>
    );
};

export default ParamTables;
